<template>
  <div class="use texture-bg-css">
    <Top></Top>
    <Storage></Storage>
    <Anything></Anything>
    <Service></Service>
  </div>
</template>

<script>
import Top from '@/components/use/Top'
import Storage from '@/components/use/Storage'
import Anything from '@/components/use/Anything'
import Service from '@/components/use/Service'

export default {
  name: 'IWant',
  scrollToTop: true,
  components: {
    Top,
    Storage,
    Anything,
    Service
  },
  mixins: [],
  data() {
    return {}
  },
  mounted: function() {},
  methods: {}
}
</script>
<style lang="scss" scoped></style>
